import React from "react";
import { Eye, Brain, Zap } from "lucide-react";

const Bar = ({ label, value, kind, testid, icon: Icon }) => {
  const critical = value < 30 && kind !== "corruption";
  const high = kind === "corruption" && value > 50;

  const labelColor =
    kind === "sanity"      ? (critical ? "text-emergency" : "text-white") :
    kind === "composure"   ? (critical ? "text-emergency" : "text-white") :
    /* corruption */         (high ? "text-emergency" : "text-blood");

  const barColor =
    kind === "sanity"    ? (critical ? "bg-emergency" : "bg-white") :
    kind === "composure" ? (critical ? "bg-emergency" : "bg-white/85") :
    /* corruption */       (high ? "bg-insanity animate-heartbeat" : "bg-blood");

  return (
    <div className="flex items-center gap-3" data-testid={testid}>
      <Icon
        size={14}
        className={`${labelColor} ${(critical || high) ? "animate-heartbeat" : ""}`}
        strokeWidth={2}
      />
      <span
        className={`font-mono text-[13px] tracking-[0.35em] uppercase ${labelColor} font-bold w-28 crt-text`}
        style={{ letterSpacing: "0.35em" }}
      >
        {label}
      </span>
      <div className="relative h-[6px] w-32 bg-black/70 border border-white/25 overflow-hidden">
        <div
          className={`absolute inset-y-0 left-0 transition-[width] duration-700 ${barColor}`}
          style={{ width: `${Math.max(0, Math.min(100, value))}%` }}
        />
      </div>
      <span className={`font-mono text-sm ${labelColor} tabular-nums w-9 text-right font-bold crt-text`}>
        {value}
      </span>
    </div>
  );
};

export const StatusBars = ({ sanity, composure, corruption }) => (
  <div
    className="flex flex-col gap-2.5 px-4 py-3 bg-black/70 border border-white/15"
    data-testid="status-bars"
  >
    <Bar label="SANITY"     value={sanity}     kind="sanity"     testid="sanity-meter"     icon={Eye} />
    <Bar label="COMPOSURE"  value={composure}  kind="composure"  testid="composure-meter"  icon={Brain} />
    <Bar label="CORRUPTION" value={corruption} kind="corruption" testid="corruption-meter" icon={Zap} />
  </div>
);
